import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Party } from "./BackEnd/Party/Party";
import { Item } from "./BackEnd/Item/Item";
import { SelectUnitList } from "./BackEnd/SelectUnit/SelectUnitList";
// import { Services } from "./BackEnd/ItemService/Services";
import { Category } from "./BackEnd/Masters/Category/Category";
import { BusinessDetails } from "./BackEnd/BusinessDetails/BusinessDetails";
import { Company } from "./BackEnd/Masters/Comapany/Company";
import { CategoryList } from "./BackEnd/Masters/Category/CategoryList";
import { CompanyList } from "./BackEnd/Masters/Comapany/CompanyList";
import { Purchase } from "./BackEnd/PurchaseExpense/PurchaseBill";
import { PaymentOutList } from "./BackEnd/PurchaseExpense/PaymentOutList";
import { Expense } from "./BackEnd/PurchaseExpense/Expense";
import { PurchaseOrder } from "./BackEnd/PurchaseExpense/PurchaseOrder";
import { DebitNote } from "./BackEnd/PurchaseExpense/DebitNote";
import { BankAccount } from "./BackEnd/CashBank/BankAccounts";
import { CashInHandList } from "./BackEnd/CashBank/CashInHandList";
import { LoanAccountList } from "./BackEnd/CashBank/LoanAccountList";
import { User } from "./BackEnd/User/User";
import { UserList } from "./BackEnd/User/UserList";
import { General } from "./Pages/Settings/General";
import { Transactions } from "./Pages/Settings/Transactions";
import { TaxesGst } from "./Pages/Settings/TaxesGst";
import { PartySettings } from "./Pages/Settings/Party";
import { ItemSettings } from "./Pages/Settings/Item";
import { Accounting } from "./Pages/Settings/Accounting";
import { SaleInvoice } from "./BackEnd/Sale/SaleInvoice";
import { Estimate } from "./BackEnd/Sale/Estimate";
import { ProformaInvoice } from "./BackEnd/Sale/ProformaInvoice";
import { SaleOrder } from "./BackEnd/Sale/SaleOrder";
import { PaymentInList } from "./BackEnd/Sale/PaymentInList";
import { DeliveryChallan } from "./BackEnd/Sale/DeliveryChallan";
import { CreditNote } from "./BackEnd/Sale/CreditNote";
import { OtherIncome } from "./BackEnd/Sale/OtherIncome";
import { VyaparPos } from "./BackEnd/Sale/VyaparPos";
import { TransactionMessage } from "./Pages/Settings/TransactionMessage";
import { Products } from "./BackEnd/OtherProducts/Products";
import { GstRegistration } from "./BackEnd/OtherProducts/GstRegistration";
import { GstReturns } from "./BackEnd/OtherProducts/GstReturns";
import { TelecallingCrm } from "./BackEnd/OtherProducts/TeleCallingCrm";
import Product from "./BackEnd/ItemService/Product";
import { BankAccountList } from "./BackEnd/CashBank/BankAccontList";
import BarcodePrint from "./BackEnd/BarCodePrint/Print";
import { ProductList } from "./BackEnd/ItemService/ProductList";
import { PartyList } from "./BackEnd/Party/PartyList";
import { Customer } from "./BackEnd/Customer/Customer";
import { CustomerList } from "./BackEnd/Customer/CustomerList";

import { SaleInvoiceList } from "./BackEnd/Sale/SaleInvoiceList";
import { InvoiceList } from "./BackEnd/Home/InvoiceList";

import PurchaseList from "./BackEnd/PurchaseExpense/PurchaseList";
import PurchaseOrderList from "./BackEnd/PurchaseExpense/PurchaseOrderList";
import ExpenseList from "./BackEnd/PurchaseExpense/ExpenseList";
import InvoicePage from "./BackEnd/Home/Invoice";
import { Reports } from "./BackEnd/Reports/Reports";
import AboutPage from "./BackEnd/About";
import ShippingLabel from "./BackEnd/Shipping/Shipping";
import { ShippingList } from "./BackEnd/Shipping/ShippingList";
import SettingsPanel from "./BackEnd/SocialMedia/SettingsPanel";
import Role from "./BackEnd/Role/Role";
import RoleList from "./BackEnd/Role/RoleList";

interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  if (!token) {
    return token ? <Outlet /> : <Navigate to="/login" />;
  }

  return (
    <Routes>
      {/* <Route path="/" element={<InvoicePage />}/> */}
      <Route path="/add-party" element={<Party />} />
      <Route path="/party/edit/:id" element={<Party />} />
      <Route path="/party/list" element={<PartyList />} />

      <Route path="/add-customer" element={<Customer />} />
      <Route path="/invoice/add-customer" element={<Customer />} />
      <Route path="/customer/edit/:id" element={<Customer />} />
      <Route path="/customer/list" element={<CustomerList />} />

      <Route path="/add-role" element={<Role />} />
      <Route path="/role/edit/:id" element={<Role />} />
      <Route path="/role/list" element={<RoleList />} />

      <Route path="/add-item" element={<Item />} />
      <Route path="/select-unit/list" element={<SelectUnitList />} />
      {/* <Route path="/item-service" element={<Services />} /> */}
      <Route path="/product/:id?" element={<Product />} />
      <Route path="/item-products/:id" element={<Product />} />
      <Route path="/products/list" element={<ProductList />} />

      <Route path="expense/product" element={<Product />} />
      <Route path="purchase/product" element={<Product />} />

      <Route path="purchase/add-party" element={<Party />} />
      <Route path="expenses/add-party" element={<Party />} />

      <Route path="/category/create" element={<Category />} />
      <Route path="/category/edit/:id" element={<Category />} />
      <Route path="/category/list" element={<CategoryList />} />

      <Route path="/company/create" element={<Company />} />
      <Route path="/company/list" element={<CompanyList />} />

      <Route path="/shipping/create" element={<ShippingLabel />} />
      {/* <Route path="/shipping/edit/:id?" element={<ShippingLabel />} /> */}
      <Route path="/shipping/list" element={<ShippingList />} />

      <Route path="/purchase" element={<Purchase />} />
      <Route path="/purchase/edit/:id" element={<Purchase />} />

      <Route path="/purchase/list" element={<PurchaseList />} />

      <Route path="/payment-out/list" element={<PaymentOutList />} />

      <Route path="/expense" element={<Expense />} />
      <Route path="/expense/edit/:id" element={<Expense />} />
      <Route path="/expense/list" element={<ExpenseList />} />

      <Route path="/debit-note" element={<DebitNote />} />

      <Route path="/Bank-account/create" element={<BankAccount />} />
      <Route path="/Bank-account/edit/:id" element={<BankAccount />} />
      <Route path="/Bank-account/list" element={<BankAccountList />} />

      <Route path="/cash-in-hand/list" element={<CashInHandList />} />

      <Route path="/loan-account/list" element={<LoanAccountList />} />

      <Route path="/user/list" element={<UserList />} />
      <Route path="/add-user" element={<User />} />
      <Route path="/user/edit/:id" element={<User />} />

      <Route path="/settings/general" element={<General />} />
      <Route path="/settings/transaction" element={<Transactions />} />
      <Route path="/settings/tax-gst" element={<TaxesGst />} />
      <Route path="/settings/party" element={<PartySettings />} />
      <Route path="/settings/items" element={<ItemSettings />} />
      <Route path="/settings/accounting" element={<Accounting />} />
      <Route
        path="/settings/business-details/:username"
        element={<BusinessDetails />}
      />

      <Route path="/reports" element={<Reports />} />

      <Route path="/sale/:id?" element={<SaleInvoice />} />
      <Route path="/sales/list" element={<SaleInvoiceList />} />

      {/* invoice */}
      <Route path="/invoice" element={<InvoicePage />} />
      <Route path="/invoice/:id" element={<InvoicePage />} />
      <Route path="/invoice/list" element={<InvoiceList />} />

      

      <Route path="/add/estimate" element={<Estimate />} />
      <Route path="/add/sale-order" element={<SaleOrder />} />
      <Route path="/add/proforma" element={<ProformaInvoice />} />
      <Route path="/add/payment-in" element={<PaymentInList />} />
      <Route path="/add/delivery-challan" element={<DeliveryChallan />} />

      <Route path="/add/credit-note" element={<CreditNote />} />
      <Route path="/add/other-income" element={<OtherIncome />} />
      <Route path="/add/vyapar-pos" element={<VyaparPos />} />

      <Route
        path="/settings/transactionmessage"
        element={<TransactionMessage />}
      />

      <Route path="/products" element={<Products />} />
      <Route path="/gst-registration" element={<GstRegistration />} />
      <Route path="/gst-return" element={<GstReturns />} />
      <Route path="/telecalling" element={<TelecallingCrm />} />

      <Route path="/about-us" element={<AboutPage />} />
      <Route path="/settings" element={<SettingsPanel />} />
    </Routes>
  );
};

export default PrivateRoute;
